<template>
  <b-overlay
    variant="white"
    :show="loadingAggs"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
    <div v-if="!loadingAggs">
      <div class="d-flex justify-content-between align-items-center">

        <h3 class="text-primary">
          Drivers Aggregations
        </h3>
        <b-button
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="fetchStats"
        >
          <feather-icon
            icon="RefreshCwIcon"
          />
        </b-button>
      </div>
      <b-table
        :fields="tableColumns"
        :items="aggs"
        hover
        striped
        responsive
        class="text-center"
        show-empty
        empty-text="No matching drivers found"
        :per-page="perPage"
        :current-page="page"
      />
      <base-pagination
        v-model="page"
        :total="total"
        @new-per-page="perPage = $event"
      />
    </div>
  </b-overlay>
</template>

<script>
import {
  BTable, BOverlay, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BTable, BOverlay, BButton, BasePagination,
  },
  props: {
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { root }) {
    const totalAvailable = ref(0)
    const totalUnAvailable = ref(0)
    const totalOccupied = ref(0)
    const totalDrivers = ref(0)
    const tableColumns = ref([])
    const aggs = ref([])
    const loadingAggs = ref(false)
    const page = ref(1)
    const perPage = ref(10)
    const total = ref()

    const fetchStats = async () => {
      try {
        loadingAggs.value = true
        totalAvailable.value = 0
        totalUnAvailable.value = 0
        totalOccupied.value = 0
        totalDrivers.value = 0
        const statsAggs = (await root.$store.dispatch('drivers/fetchStatsAggs', {
          serviceType: props.serviceType,
        })).data?.data?.aggregations?.driver_zone?.buckets
        aggs.value = statsAggs?.map(item => {
          totalDrivers.value += item.doc_count
          const obj = {
            total: item.doc_count,
          }
          let temp = 0
          item.location_status?.driver_status?.buckets?.map(i => {
            if (i.key === 'UNAVAILABLE') {
              obj.unavailable = i.doc_count
              totalUnAvailable.value += i.doc_count
            }
            if (i.key === 'AVAILABLE') {
              obj.available = i.doc_count
              temp += i.doc_count
              totalAvailable.value += i.doc_count
            }
            if (i.key === 'OCCUPIED') {
              obj.occupied = i.doc_count
              temp += i.doc_count
              totalOccupied.value += i.doc_count
            }
            // eslint-disable-next-line prefer-template, no-useless-concat
            obj.zone = item.key + ' ' + '(' + temp + ')'
            return obj
          })
          return obj
        })
        tableColumns.value = [
          {
            key: 'zone',
            label: `Zones(${totalOccupied.value + totalAvailable.value})`,
          },
          {
            key: 'occupied',
            label: `occupied(${totalOccupied.value})`,
          },
          {
            key: 'available',
            label: `available(${totalAvailable.value})`,
          },
          {
            key: 'unavailable',
            label: `unavailable(${totalUnAvailable.value})`,
          },
          {
            key: 'total',
            label: `total(${totalDrivers.value})`,
          },
        ]
        total.value = aggs.value.length
      } catch (error) {
        console.log(error)
      } finally {
        loadingAggs.value = false
      }
    }
    fetchStats()
    return {
      tableColumns,
      aggs,
      loadingAggs,
      fetchStats,
      page,
      perPage,
      total,
    }
  },
}
</script>

<style>

</style>
